<template>
  <div class="bhd">
    <div
      style="position: absolute;top: 3px;right: 10px;font-size: 20px;color: #999;cursor: pointer;"
      :title="horizontal ? '横向' :'横向'"
    >
      <i class="el-icon-s-operation" @click="horizontal = !horizontal"></i>
    </div>
    <!--  @on-node-click="NodeClick" -->
    <vue2-org-tree
      :data="data"
      :renderContent="renderContent"
      :collapsable="true"
      @on-expand="onExpand"
      :key="orgKey"
       @on-node-click="NodeClick" 
      :horizontal="horizontal"
    />
    <div style="padding:10px;" v-if="userInfo.director && notset.length > 0">
      <h1>未分人员</h1>
      <div class="noset">
        <div
          class="org-tree-node-label-inner"
          v-for="(e, i) in notset"
          :key="i"
          @click="NodeClick(null, e)"
        >
          <div class="node">
            <div class="row1">
              <div class="r1l">
                <div class="empname">
                  {{ e.empname }}<span>({{ e.sjxm }}/{{ e.bzxm }})</span>
                </div>
                 <el-progress
                  type="circle"
                  width="40"
                  strokeWidth="3"
                  :percentage="e.baohedu"
                  :color="color"
                />
                <div class="st">
                  执行总量:<span>{{ e.zhixingzongliang }}</span>
                </div>
                <div class="st">
                  实际执行量:<span>{{ e.shijizhixingliang }}</span>
                </div>
              </div>
              <!-- <div class="r1r">
                <el-progress
                  type="circle"
                  width="40"
                  strokeWidth="3"
                  :percentage="e.baohedu"
                  :color="color"
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <veaDialog
      title="员工设置"
      class="bhdsetForm"
      :show.sync="showSetBit"
      :before-close="closeDialogSet"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="所属上级">
          <el-select
            clearable
            v-model="form.topempcode"
            placeholder="请选择上级"
          >
            <el-option
              v-for="item in emplist"
              :key="item.empcode"
              :label="item.empname"
              :value="item.empcode"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标准项目数量">
          <el-input
            v-model="form.bzxm"
            type="number"
            style="width:180px;"
          ></el-input>
        </el-form-item>
      </el-form>
    </veaDialog>
    <!-- 项目情况汇报 -->
    <veaDialog
      title="项目情况汇报"
      class="listForm"
      :show.sync="showlist"
      :before-close="closeDialoglist"
    >
      <div
        v-for="(item, i) in prolist"
        :key="i"
        class="prolist"
        @click="goto(item)"
      >
        <h2>{{ item.name + '-' + item.ctname }}</h2>
        <el-progress :percentage="item.jd" :color="color" />
      </div>
      <template slot="footer-right">
        <div>
          <el-button
            v-if="userInfo.director"
            type="primary"
            size="medium"
            v-preventReClick
            @click="showSetBit = true"
            >{{ '员工设置' }}</el-button
          >
        </div>
      </template>
    </veaDialog>
  </div>
</template>

<script>
import { GetBHDlist, UpdateBHD, GetProject } from '@api/api.js'
export default {
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
      data: {
        id: 0,
        label: '开始',
        children: [],
        expand: true
      },
      notset: [],
      color: [
        { color: '#5cb87a', percentage: 20 },
        { color: '#1989fa', percentage: 50 },
        { color: '#e6a23c', percentage: 80 },
        { color: '#f56c6c', percentage: 100 }
      ],
      form: { bzxm: 0, topempcode: null },
      showSetBit: false,
      showlist: false,
      emplist: [],
      porjectlist: [],
      prolist: [],
      horizontal: false,
      orgKey:0
    }
  },
  created() {
    this._GetBHDlist()
    this._GetProject()
  },
  methods: {
    _GetProject() {
      GetProject({ name: '管理员' }).then(res => {
        this.porjectlist = res.list
      })
    },
    //渲染节点
    renderContent(h, data) {
      return data.id == 0 ? (
        <span>{data.label}</span>
      ) : (
        h('div', { class: 'node' }, [
          h('div', { class: 'row1' }, [
            h('div', { class: 'r1l' }, [
              h('div', { class: 'empname' }, [
                data.empname,
                h('span', null, `(${data.sjxm}/${data.bzxm})`)
              ]),
              h('el-progress', {
                props: {
                  type: 'circle',
                  width: 40,
                  strokeWidth: 3,
                  percentage: data.baohedu,
                  color: this.color
                }
              }),
              h('div', { class: 'st' }, [
                '执行总量:',
                h('span', null, `(${data.zhixingzongliang})`)
              ]),
              h('div', { class: 'st' }, [
                '实际执行量:',
                h('span', null, `(${data.shijizhixingliang})`)
              ])
            ]),
            // h('div', { class: 'r1r' }, [
            //   h('el-progress', {
            //     props: {
            //       type: 'circle',
            //       width: 40,
            //       strokeWidth: 3,
            //       percentage: data.baohedu,
            //       color: this.color
            //     }
            //   })
            // ])
          ])
        ])
      )
    },
    closeDialogSet(a) {
      if (a == 'confirm') {
        // 保存
        UpdateBHD(this.form)
          .then(res => {
            if (res.error == '0') {
              this.$message.success('保存成功')
              this.showSetBit = false
            } else {
              this.$message.error(res.errorinfo)
            }
          })
          .finally(res => {
            this._GetBHDlist()
          })
      } else {
        this.showSetBit = false
      }
    },
    closeDialoglist(a) {
      this.showlist = false
    },
    NodeClick(e, data) {
      this.form = data
      this.showlist = true
      this.prolist = this.porjectlist.filter(e => {
        return (
          e.ServiceMan == data.empname ||
          e.ServiceMan2 == data.empname ||
          e.ServiceMan3 == data.empname ||
          e.Service_Manager == data.empname
        )
      })
      // console.log(e, data, 'NodeClick')
    },
    _GetBHDlist() {
      this.data = {
        id: 0,
        label: '开始',
        children: [],
        expand: true
      }
      GetBHDlist().then(res => {
        res.list
        let arr1 = [],
          arr2 = [[], []], // 先预设3层，后续再增加
          arr3 = []
        this.emplist = res.list
        res.list.forEach(e => {
          e.children = []
          e.expand = true
          if (
            (e.topempcode == '0' && this.userInfo.director) || // 总监
            (!this.userInfo.director && e.empname == this.userInfo.name) // 当前员工
          ) {
            // 首个节点，萧总
            this.data.children.push(e)
            arr2[0] = [e.empcode]
          } else if (e.topempcode) {
            // 有设置上级
            if (e.topempcode == arr2[0][0]) {
              // 经理
              this.data.children[0].children.push(e)
              arr2[1].push(e.empcode)
            } else {
              // 工程师
              if (arr2[1].indexOf(e.topempcode) > -1) {
                this.data.children[0].children[
                  arr2[1].indexOf(e.topempcode)
                ].children.push(e)
              } else {
                arr3.push(e)
              }
            }
          } else {
            arr3.push(e)
          }
        })
        console.log(arr1, arr2, arr3)
        this.notset = arr3
      })
    },
    //展开
    onExpand(e, data) {      
      if ('expand' in data) {
        data.expand = !data.expand
        this.orgKey++
        if (!data.expand && data.children) {
          // this.collapse(data.children)
        }
      } else {
        this.$set(data, 'expand', true)
      }
      this.$forceUpdate()
      // data.expand=!data.expand
    },
    goto(item) {
      let path = '/main/project/pre'
      let query = {
        autoid: item.autoid,
        cbd: item.cbd,
        ced: item.yj_jadate || item.ced,
        name: item.name + '-' + item.ctname
      }
      this.$router.push({ path: path, query: query })
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.bhd {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  min-height: 100%;
  position: relative;
}
/deep/ .org-tree {
  // 隐藏开始节点
  > .org-tree-node {
    > .org-tree-node-label {
      display: none;
    }
    > .org-tree-node-children::before {
      display: none;
    }
    > .org-tree-node-children {
      > .org-tree-node::after {
        display: none;
      }
    }
  }
}
.noset {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
/deep/ .org-tree-node-label-inner {
  padding: 0;
  border: solid 1px rgb(0, 102, 255);
  border-top-width: 7px;
  border-radius: 10px;
  .node {
    width: 155px;
    height: 180px;
    padding: 10px 5px;
    .row1 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .r1l {
        // width: 220px;
        .empname {
          font-size: 30px;
          font-weight: bold;
          span {
            font-size: 18px;
            font-weight: normal;
            color: rgb(0, 102, 255);
          }
        }
        .st {
          text-align: left;
          color: #666;
          padding: 5px 0;
          span {
            color: #000;
          }
        }
      }
      .r1r {
        .el-progress {
          .el-progress__text {
            font-size: 12px !important;
          }
        }
      }
    }
  }
}

.bhdsetForm {
  /deep/ .el-dialog {
    width: 500px;
  }
}
.listForm {
  /deep/ .el-dialog {
    @include wh(800px, 88vh);
    padding: 10px;
    .el-dialog__body {
      height: calc(100% - 300px);
      overflow-y: auto;
    }
    .prolist {
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
      h2 {
        padding: 0;
        margin: 0;
      }
    }
    .prolist:hover {
      background: rgb(230, 255, 241);
      cursor: pointer;
    }
  }
}
/deep/ .org-tree-node-btn,
/deep/ .org-tree-node:not(:first-child):before, 
/deep/ .org-tree-node:not(:last-child):after,
/deep/ .org-tree-node:before, 
/deep/ .org-tree-node:after,
/deep/ .org-tree-node-children:before,
/deep/ .collapsable .org-tree-node.collapsed .org-tree-node-label:after,
/deep/ .org-tree-node-btn:after,
/deep/ .org-tree-node-btn:before
{
   border-color: #000;
}
</style>
